import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Link } from 'react-router-dom';

const MutualFundsPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-black via-gray-900 to-black">
      <Navbar />
      
      <div className="pt-32 pb-20 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6">
              Mutual Funds
            </h1>
            <p className="text-lg text-white/70 max-w-3xl mx-auto">
              Discover expert guidance on equity, debt, hybrid funds, SIFs, PMS, and AIFs at Frontier Investments. Smarter mutual fund investing starts here.
            </p>
          </div>

          {/* Equity Funds Section */}
          <section id="equity" className="mb-20">
            <div className="grid lg:grid-cols-2 gap-12 items-center">
              <div className="relative group">
                <div className="absolute inset-0 bg-gradient-to-r from-blue-500/20 to-purple-500/20 rounded-2xl blur-xl group-hover:blur-2xl transition-all duration-300"></div>
                <img 
                  src="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800&q=80" 
                  alt="Equity Funds - Professional Investment Growth"
                  className="relative rounded-2xl shadow-2xl w-full object-cover hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div>
                <h2 className="text-3xl lg:text-4xl font-bold text-white mb-6">Equity Funds</h2>
                <p className="text-white/70 mb-4">
                  At Frontier Investment, we specialize in guiding you through equity mutual funds — schemes that invest primarily in stocks of companies across sectors and market capitalizations. These funds aim for long-term capital growth, making them ideal for wealth creation over time.
                </p>
                <p className="text-white/70">
                  Equity funds can be volatile in the short term, but with the right strategy, they offer strong potential returns. Our experts help you choose equity funds that match your financial goals, investment horizon, and risk profile, whether you're a first-time investor or looking to rebalance your portfolio.
                </p>
              </div>
            </div>
          </section>

          {/* Debt Funds Section */}
          <section id="debt" className="mb-20">
            <div className="grid lg:grid-cols-2 gap-12 items-center">
              <div className="order-2 lg:order-1">
                <h2 className="text-3xl lg:text-4xl font-bold text-white mb-6">Debt Funds</h2>
                <p className="text-white/70 mb-4">
                  At Frontier Investment, we offer expert guidance on debt mutual funds — schemes that invest in fixed-income instruments like government securities, corporate bonds, treasury bills, and other money market assets. These funds are designed to offer stable returns with lower risk, making them ideal for conservative investors or short- to medium-term goals.
                </p>
                <p className="text-white/70">
                  Unlike equity funds, debt funds prioritize capital preservation and income generation over aggressive growth. Whether you're looking for better returns than a savings account or a steady stream of income, our team helps you select debt funds aligned with your risk appetite, liquidity needs, and time horizon.
                </p>
              </div>
              <div className="order-1 lg:order-2 relative group">
                <div className="absolute inset-0 bg-gradient-to-r from-green-500/20 to-emerald-500/20 rounded-2xl blur-xl group-hover:blur-2xl transition-all duration-300"></div>
                <img 
                  src="https://images.unsplash.com/photo-1579621970563-ebec7560ff3e?w=800&q=80" 
                  alt="Debt Funds - Fixed Income"
                  className="relative rounded-2xl shadow-2xl w-full object-cover hover:scale-105 transition-transform duration-300"
                />
              </div>
            </div>
          </section>

          {/* Hybrid Schemes Section */}
          <section id="hybrid" className="mb-20">
            <div className="grid lg:grid-cols-2 gap-12 items-center">
              <div className="relative group">
                <div className="absolute inset-0 bg-gradient-to-r from-purple-500/20 to-pink-500/20 rounded-2xl blur-xl group-hover:blur-2xl transition-all duration-300"></div>
                <img 
                  src="https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80" 
                  alt="Hybrid Schemes - Diversified Portfolio"
                  className="relative rounded-2xl shadow-2xl w-full object-cover hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div>
                <h2 className="text-3xl lg:text-4xl font-bold text-white mb-6">Hybrid Schemes</h2>
                <p className="text-white/70 mb-4">
                  At Frontier Investment, we help you explore hybrid mutual funds — schemes that invest in a mix of equity and debt instruments, offering a balanced approach to growth and stability. These funds are ideal for investors seeking moderate returns with controlled risk.
                </p>
                <p className="text-white/70">
                  Hybrid funds combine the high-growth potential of equities with the steady income of debt, making them suitable for those who want diversification in a single package. Whether you're a cautious investor looking for equity exposure or aiming to reduce portfolio volatility, we guide you to the right blend of assets based on your goals and risk profile.
                </p>
              </div>
            </div>
          </section>

          {/* SIF Section */}
          <section id="sif" className="mb-20">
            <div className="grid lg:grid-cols-2 gap-12 items-center">
              <div className="order-2 lg:order-1">
                <h2 className="text-3xl lg:text-4xl font-bold text-white mb-6">SIF</h2>
                <p className="text-white/70 mb-4">
                  At Frontier Investment, we specialize in Specialized Investment Funds (SIFs) — exclusive SEBI-approved funds designed for high-net-worth investors looking for more flexibility and control. SIFs offer advanced strategies like long-short equity and sector rotation, giving you smarter ways to invest beyond traditional mutual funds.
                </p>
                <p className="text-white/70">
                  With a minimum investment of ₹10 lakh, SIFs provide tailored, active management that adapts to market shifts while aiming for higher returns. Trust us to guide you through these distinct, powerful investment options and help you unlock your portfolio's full potential.
                </p>
              </div>
              <div className="order-1 lg:order-2 relative group">
                <div className="absolute inset-0 bg-gradient-to-r from-amber-500/20 to-yellow-500/20 rounded-2xl blur-xl group-hover:blur-2xl transition-all duration-300"></div>
                <img 
                  src="https://images.unsplash.com/photo-1610375461246-83df859d849d?w=800&q=80" 
                  alt="SIF - Premium Investment"
                  className="relative rounded-2xl shadow-2xl w-full object-cover hover:scale-105 transition-transform duration-300"
                />
              </div>
            </div>
          </section>

          {/* Loan Against Mutual Funds Section */}
          <section id="loan" className="mb-20">
            <div className="grid lg:grid-cols-2 gap-12 items-center">
              <div className="relative group">
                <div className="absolute inset-0 bg-gradient-to-r from-cyan-500/20 to-blue-500/20 rounded-2xl blur-xl group-hover:blur-2xl transition-all duration-300"></div>
                <img 
                  src="https://images.unsplash.com/photo-1633158829585-23ba8f7c8caf?w=800&q=80" 
                  alt="Loan Against Mutual Funds - Financial Liquidity"
                  className="relative rounded-2xl shadow-2xl w-full object-cover hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div>
                <h2 className="text-3xl lg:text-4xl font-bold text-white mb-6">Loan Against Mutual Funds</h2>
                <p className="text-white/70 mb-4">
                  A loan against mutual funds allows you to borrow by pledging your mutual fund units, without redeeming them. It's a smart way to access funds quickly while your investments continue to earn returns. Interest rates are typically lower than personal loans, making it a cost-effective option.
                </p>
                <p className="text-white/70">
                  Frontier Investments streamlines the process with quick approvals, minimal documentation, and flexible terms. Whether it's for personal needs or business goals, they help you unlock the value of your portfolio without breaking your investments.
                </p>
              </div>
            </div>
          </section>

          <div className="text-center mt-16">
            <Link
              to="/contact"
              className="inline-block px-8 py-4 bg-white text-black font-semibold rounded-full hover:shadow-[0_0_30px_rgba(255,255,255,0.3)] transition-all duration-300"
            >
              Get Started with Mutual Funds
            </Link>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default MutualFundsPage;